import React, { useState, useRef } from "react"
import { API_URL } from "../../../utils/helpers"
import { db } from "../../../utils/firebase"
import Input from "../../Input"
import Msg from "../../Msg"
import Submit from "../../Submit"
import { Container } from "./styled"
import { Form } from "../../../elements/Layout/styled"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRoute, faChevronCircleRight } from "@fortawesome/pro-light-svg-icons"
import {
  faInstagram,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons"

const Footer = () => {
  const [errors, setErrors] = useState([])
  const [names, setNames] = useState({})
  const [msg, setMsg] = useState({})

  const formElement = useRef(null)

  const site = "evo"

  const handleUpdate = (name, value) => {
    setNames(names => ({ ...names, [name]: value ? value : "" }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setErrors([])
    setMsg({
      type: "working",
      text: "",
    })

    const url = new URL(`${API_URL}/${site}email`)
    let data = new FormData()
    Object.entries(names).forEach(([key, value]) => data.append(key, value))
    data.append("site", site || "")

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      })
      const json = await response.json()
      if (json && json.resp === 1) {
        db.collection(`emails`)
          .add({
            site: site,
            email: names.email,
            comments: names.comments,
            createdAt: new Date(),
          })
          .then(function(docRef) {
            //console.log("Document written with ID: ", docRef.id)
          })
          .catch(function(error) {
            console.error("Error adding document: ", error)
          })

        formElement.current.reset()
        handleUpdate("email", "")
        handleUpdate("comments", "")
        setMsg({
          type: "success",
          text: json.text,
        })
      } else {
        setErrors(json.fields)
        setMsg({
          type: "error",
          text: json.text,
        })
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      })
    }
  }

  return (
    <Container>
      <div>
        <div>
          <h2>Order Pickup</h2>
          <p>
            150 North US Highway 1
            <br />
            Tequesta, FL 33469
          </p>
          <span>
            <a href="https://www.google.com/maps/place/Evo+Italian/@26.9615483,-80.0873179,17z/data=!3m1!4b1!4m5!3m4!1s0x88df28328605b277:0xbdfacd32281110b7!8m2!3d26.9615435!4d-80.0851292?shorturl=1">
              <FontAwesomeIcon icon={faRoute} size="2x" />
            </a>
          </span>
        </div>

        <div>
          <h2>Reach Out</h2>
          <p>
            (561) 745-2444
            <br />
            <a href="mailto:info@evoitalian.com">info@evoitalian.com</a>
          </p>
          <span>
            <a href="https://www.instagram.com/evoitalian/">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a href="https://www.facebook.com/evoitalian/">
              <FontAwesomeIcon icon={faFacebook} size="2x" />
            </a>
            <a href="https://www.youtube.com/channel/UC9F4DygJ0vTSyp8gr17U0aQ">
              <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
          </span>
        </div>
        <div>
          <h2>Send an Email</h2>

          <Form
            method="post"
            action="/"
            onSubmit={e => handleSubmit(e)}
            className="email"
            ref={formElement}
          >
            <div>
              <Input
                type="text"
                label="Email"
                req={true}
                name="email"
                value={names.email}
                update={handleUpdate}
                errors={errors}
                autocomplete="email"
                smaller={true}
              />
            </div>
            <div>
              <Input
                type="text"
                label="Message"
                req={true}
                name="comments"
                value={names.comments}
                update={handleUpdate}
                errors={errors}
                smaller={true}
              />
            </div>

            <div className="msg-submit">
              {msg.type && <Msg data={msg} />}

              <div
                className={
                  msg.type === "working" ? "hidden" : "submit-container"
                }
              >
                <Submit
                  name="Send Email"
                  icon={faChevronCircleRight}
                  smaller={true}
                />
              </div>
            </div>
          </Form>
        </div>
      </div>

      <p className="copy">
        © 2020 Menuline Online Ordering for Evo Italian. All rights reserved.
      </p>
    </Container>
  )
}

export default Footer
